export default __webpack_public_path__ + "static/media/benefit_14.f59ded50.png";